import React from 'react';
import PropTypes from 'prop-types';
import { Heading } from '@domain-group/fe-co-allhomes-design-system';
import * as styles from './share-details.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var SharePreferences = props => {
  var suitabilityItems = (props.suitability || []).map(item => ___EmotionJSX("li", {
    css: styles.listItem,
    key: item
  }, "\u2022\xA0\xA0", item));
  return ___EmotionJSX("section", {
    css: styles.shareDetails
  }, ___EmotionJSX(Heading, {
    css: styles.heading,
    title: "Applicant preferences"
  }), ___EmotionJSX("ul", {
    css: styles.list
  }, suitabilityItems));
};
SharePreferences.propTypes = {
  suitability: PropTypes.arrayOf(PropTypes.string)
};
SharePreferences.defaultProps = {
  suitability: []
};
export default SharePreferences;